import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-148" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-149" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-150" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-gold bg-gold-soft text-forest font-bold text-xs sm:text-sm tracking-widest whitespace-nowrap mb-4 sm:mb-6" data-id="element-151" data-mp="3d21ty23jwspu">
            WORKPLACE SAFETY ATLAS
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-ink uppercase" data-id="element-152" data-mp="3j923fiwkdgsw">
            Solve <span className="text-forest" data-id="element-153" data-mp="39auqdb5ebiw6">Months of Workplace Safety Training</span> Lesson
            Planning <span className="text-gold" data-id="element-154" data-mp="3e8wkqs89v4my">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-155" data-mp="30hhq1o505f02">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-156" data-mp="2viy2xkeo9x64" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-157" data-mp="2hl9sl6i8e8fb">
          <p className="text-sm sm:text-lg md:text-xl text-graphite leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-158" data-mp="s3us1zznrec7">
            The Complete{' '}
            <span className="font-semibold text-forest" data-id="element-159" data-mp="id9u8ert6duc">
              6-IN-1 Visual Training System for Workplace Safety Instructors
            </span>
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-graphite leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-160" data-mp="1b0w05toidukd">
            <span className="font-semibold text-ink" data-id="element-161" data-mp="161az9dps3c50">6 Professional Visual Training Volumes</span> + 5
            Exclusive Bonuses — Everything organized to help you prepare, explain, demonstrate and
            assess workplace safety concepts with greater clarity, structure and confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-gold-dark mb-5 sm:mb-7" data-id="element-162" data-mp="3lt76ct9j5vvb">
            100% VISUAL TRAINING | READY-TO-TEACH RESOURCES | BEGINNER TO ADVANCED
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-163" data-mp="1xa41h7xz88gg">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-164" data-mp="1x7hwng2h071x">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-graphite/80 mb-3" data-id="element-165" data-mp="2b1hl0lvvx6bh">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-166" data-mp="2kynbbrwoctan">
                <CheckCircle size={14} className="text-forest" data-id="element-167" data-mp="2l0zyqkl7bvv3" />
                <span className="font-medium" data-id="element-168" data-mp="2p1sabkhjqcuj">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-graphite/60" data-id="element-169" data-mp="2tz1xsuldkefq">
            6 SPECIALIZED ATLASES · 100% VISUAL SYSTEM · 5 EXCLUSIVE BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}